module.exports = __webpack_public_path__ + "5d28e2a630cfa74b32b8caa5526f488a.jpg";